import { Notification } from '@app/shared';

export enum ToastLevel
{
    None,
    Information,
    Warning,
    Success
}

export class ToastMessage
{
    public content: any;
    public level: ToastLevel;
    public extra: string;

    static create(content: any, level: ToastLevel = ToastLevel.None, extra: string= "")
    {
        let t = new ToastMessage();
        t.content = content;
        t.level = level;
        t.extra = extra;

        return t;
    }
    
    // constructor(content: any, level: ToastLevel = ToastLevel.None, extra: string= "")
    // {
    //     this.content = content;
    //     this.level = level;
    //     this.extra = extra;
    // }
}